module.exports = __webpack_public_path__ + "img/impactoE3.686b810c.png";